import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion"; // Import AnimatePresence
import { Helmet } from "react-helmet-async";
import JoinNowFormPopup from "../../../componants/JoinNowFormPopup";

// Helper component for Star Rating (reused)
const StarRating = ({ rating }: { rating: number }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <svg
        key={i}
        className={`h-4 w-4 ${
          i <= rating ? "text-yellow-400" : "text-gray-300"
        } inline-block`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
      </svg>
    );
  }
  return <div className="flex items-center">{stars}</div>;
};

// Helper component for Verified Badge (reused)
const VerifiedBadge = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ml-2">
    <svg
      className="w-3 h-3 mr-1"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
    Verified
  </span>
);

const MernCertification = () => {
  const testimonials = [
    {
      id: 1,
      name: "Rohan Sharma",
      review:
        "The MERN Stack certification course at Nadezhda Venture was a game-changer for my career. The comprehensive curriculum and hands-on projects helped me build robust full-stack applications. The instructors were excellent and the placement assistance was truly valuable!",
      rating: 5,
      date: "2024-06-10",
      profileImg: "https://randomuser.me/api/portraits/men/32.jpg", // Random male profile image
    },
    {
      id: 2,
      name: "Priya Gupta",
      review:
        "I'm thrilled with my MERN certification from Nadezhda Venture. The practical exposure to MongoDB, Express, React, and Node.js was exactly what I needed. Highly recommend for anyone looking to master full-stack development in Noida!",
      rating: 4,
      date: "2024-06-05",
      profileImg: "https://randomuser.me/api/portraits/women/44.jpg", // Random female profile image
    },
    {
      id: 3,
      name: "Amit Kumar",
      review:
        "Fantastic experience! The MERN stack training was thorough, covering everything from database design to frontend development. The certification boosted my confidence and opened new opportunities.",
      rating: 5,
      date: "2024-05-28",
      profileImg: "https://randomuser.me/api/portraits/men/50.jpg", // Random male profile image
    },
    {
      id: 4,
      name: "Deepika Singh",
      review:
        "Nadezhda Venture provides top-notch MERN training. The real-time projects were incredibly helpful in understanding how all the MERN components work together. The certification is well-recognized.",
      rating: 4,
      date: "2024-05-20",
      profileImg: "https://randomuser.me/api/portraits/women/61.jpg", // Random female profile image
    },
    {
      id: 5,
      name: "Manish Verma",
      review:
        "Learned so much from the MERN stack course. The instructors are patient and very knowledgeable. The certification process was smooth and added significant value to my resume.",
      rating: 4,
      date: "2024-05-15",
      profileImg: "https://randomuser.me/api/portraits/men/77.jpg", // Random male profile image
    },
  ];

   const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
      const [selectedCourseTitle, setSelectedCourseTitle] = useState(""); // State to store the course title
    
      const handleOpenPopup = (courseTitle: string) => { // Function to open the popup
        setSelectedCourseTitle(courseTitle); // Set the selected course title
        setIsPopupOpen(true); // Open the popup
      };
    
      const handleClosePopup = () => { // Function to close the popup
        setIsPopupOpen(false); // Close the popup
        setSelectedCourseTitle(""); // Clear selected course when closing
      };

  const faqContent = [
    {
      title: "What is the MERN Stack?",
      answer:
        "The MERN stack is a popular collection of technologies used for building robust web applications. It comprises **M**ongoDB (a NoSQL database), **E**xpress.js (a Node.js web application framework), **R**eact.js (a JavaScript library for building user interfaces), and **N**ode.js (a JavaScript runtime environment). Together, they provide an end-to-end framework for full-stack web development.",
    },
    {
      title: "Who is this MERN Certification for?",
      answer:
        "This certification is ideal for aspiring web developers, computer science students, and professionals looking to become proficient in full-stack development. If you have basic programming knowledge and a desire to build dynamic web applications, this course is for you.",
    },
    {
      title: "What are the prerequisites for this course?",
      answer:
        "A basic understanding of HTML, CSS, and JavaScript is recommended. While not strictly required, familiarity with fundamental programming concepts will help you get the most out of this certification program.",
    },
    {
      title: "What kind of projects will I work on?",
      answer:
        "You will work on several hands-on projects throughout the course, ranging from simple web applications to complex, real-world scenarios. These projects will cover all aspects of the MERN stack, including database integration, API development, and dynamic UI creation. You'll build a portfolio that showcases your skills.",
    },
    {
      title: "How does the certification process work?",
      answer:
        "Upon successful completion of the course modules, hands-on projects, and a final assessment, you will be awarded a **MERN Stack Developer Certificate** from Nadezhda Venture. This certificate validates your proficiency in building full-stack applications using MERN technologies and enhances your professional credibility.",
    },
    {
      title: "Is placement assistance provided?",
      answer:
        "Yes, we offer dedicated placement assistance to our certified MERN stack developers. This includes resume building workshops, mock interview sessions, and connecting you with our network of hiring partners in Noida and across India to help you land your dream job.",
    },
    {
      title: "What career opportunities does MERN certification open?",
      answer:
        "A MERN certification prepares you for roles such as Full-Stack Developer, Frontend Developer (React.js), Backend Developer (Node.js/Express.js), MongoDB Developer, and JavaScript Developer. The demand for MERN stack developers is consistently high in the industry.",
    },
    {
      title: "What is the duration of the MERN Certification course?",
      answer:
        "The course duration varies based on the learning mode (e.g., weekday, weekend, fast-track). Please refer to our course brochure or contact us for the specific duration and batch timings that suit your schedule.",
    },
    {
      title: "Can I get a demo class before enrolling?",
      answer:
        "Yes, we offer free demo classes where you can experience our teaching methodology, interact with instructors, and get a clearer understanding of the MERN stack curriculum. Contact us to schedule your demo class.",
    },
    {
      title: "What makes Nadezhda Venture the best for MERN training in Noida?",
      answer:
        "Nadezhda Venture stands out due to its industry-expert instructors, practical project-based learning, updated curriculum, strong placement support, and a supportive learning environment. Our focus is on making you job-ready.",
    },
  ];

  const certificationDetails = [
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      ),
      title: "Industry-Recognized Certification",
      description:
        "Receive a certificate that's valued by top tech companies, validating your MERN stack expertise.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          ></path>
        </svg>
      ),
      title: "Project-Based Learning",
      description:
        "Build a strong portfolio with multiple real-world MERN projects throughout the course.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          ></path>
        </svg>
      ),
      title: "Comprehensive Curriculum",
      description:
        "Master MongoDB, Express.js, React.js, and Node.js with a structured and up-to-date syllabus.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c1.657 0 3 .895 3 2s-1.343 2-3 2-3-.895-3-2 1.343-2 3-2zM21 12c0 8-9 16-9 16S3 20 3 12a9 9 0 1118 0z"
          ></path>
        </svg>
      ),
      title: "100% Placement Assistance",
      description:
        "Benefit from our strong industry connections and dedicated support for job placements.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
          ></path>
        </svg>
      ),
      title: "Expert Instructors",
      description:
        "Learn from seasoned developers with years of industry experience in MERN stack.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 10V3L4 14h7v7l9-11h-7z"
          ></path>
        </svg>
      ),
      title: "Live Project Exposure",
      description:
        "Gain invaluable experience by working on live projects, simulating real development environments.",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(autoScrollInterval); // Clean up the interval
  }, [testimonials.length]);

  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonials.length
    );
  };

  // Determine how many testimonials to show at once (e.g., 1 on small, 2 on medium, 3 on large)
  const getVisibleTestimonialsCount = () => {
    if (window.innerWidth >= 1024) return 3; // lg breakpoint
    if (window.innerWidth >= 768) return 2; // md breakpoint
    return 1; // default for small screens
  };

  const [visibleCount, setVisibleCount] = useState(
    getVisibleTestimonialsCount()
  );

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleTestimonialsCount());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startIndex = currentTestimonialIndex;
  const endIndex =
    startIndex + visibleCount > testimonials.length
      ? testimonials.length
      : startIndex + visibleCount;
  const currentVisibleTestimonials = [];

  for (let i = startIndex; i < endIndex; i++) {
    currentVisibleTestimonials.push(testimonials[i]);
  }

  // Handle wrapping around for fewer than visibleCount items at the end
  if (
    currentVisibleTestimonials.length < visibleCount &&
    testimonials.length >= visibleCount
  ) {
    const remaining = visibleCount - currentVisibleTestimonials.length;
    for (let i = 0; i < remaining; i++) {
      currentVisibleTestimonials.push(testimonials[i]);
    }
  } else if (testimonials.length < visibleCount) {
    // If total testimonials are less than visible count, just show all
    currentVisibleTestimonials.push(...testimonials);
  }

  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>MERN Stack Certification Training in Noida | Full-Stack Course</title>
        <meta
          name="description"
          content="Become a certified MERN Stack developer in Noida. Our comprehensive training covers MongoDB, Express.js, React.js, and Node.js with hands-on projects and placement support."
        />
        <meta
          name="keywords"
          content="MERN stack training Noida, MERN certification, Full-stack development course, MongoDB, Express.js, React.js, Node.js, MERN placement Noida"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[400px] bg-gray-900 flex items-center">
        <img
          src="https://ifda.in/lading-page-img/web-designing-banner.jpg"
          alt="MERN Stack Training Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
          <div className="md:w-1/2">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-extrabold leading-tight text-left"
            >
              <span className="text-teal-400">MERN</span> Certification Training in Noida
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="mt-6 text-lg md:text-xl text-gray-200 text-left"
            >
              Become a full-stack web developer with our comprehensive MERN certification program. Learn MongoDB, Express.js, React.js, and Node.js with hands-on projects.
            </motion.p>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="mt-8 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out"
            >
               <button
                    // className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition text-white"
                    onClick={() => handleOpenPopup("Mern Certification Course")} // Pass the course title
                  >
                    Enroll Now !
                  </button>
            </motion.button>
          </div>
        </div>
      </section>

      {/* Certification Highlights Section */}
      <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">
            Why Choose Our MERN Certification?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {certificationDetails.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center"
              >
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-700">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Course Content / FAQ Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">
            Frequently Asked Questions (FAQ) & Course Curriculum
          </h2>
          <div className="space-y-4">
            {faqContent.map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Enquiry Form */}
        <div className="md:col-span-1 pt-48">
          <div className="bg-blue-300 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">
              Enquire Now
            </h3>
            <p className="text-center text-gray-600 mb-6">
              Fill out the form below to get more details about our MERN Stack certification program.
            </p>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="Course of Interest (e.g., MERN Certification)"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="College/University Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg"
              >
                GET CERTIFIED
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Testimonial Section - No Horizontal Scrollbar */}
      <section className="bg-blue-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">
            Our Students Say
          </h2>

          <div className="relative overflow-hidden w-full mx-auto">
            {/* Left Scroll Button */}
            <button
              onClick={goToPrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Previous testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            {/* Testimonial Cards Container */}
            <div className="flex justify-center items-stretch space-x-6 md:space-x-8 lg:space-x-10">
              <AnimatePresence mode="wait" initial={false}>
                {currentVisibleTestimonials.map((testimonial, idx) => (
                  <motion.div
                    key={testimonial.id} // Key by testimonial ID for consistent animation
                    initial={{ opacity: 0, x: idx * 100 }} // Initial position based on index in visible set
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="flex-none w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] p-2"
                    // w-[calc(50%-1.5rem)] means 50% width minus half of the space-x-6 (3rem total gap)
                    // w-[calc(33.333%-2rem)] means 33.333% width minus two-thirds of the space-x-6 (4rem total gap)
                  >
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 flex flex-col h-full text-left">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.profileImg}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-blue-200"
                        />
                        <div>
                          <p className="font-bold text-gray-900 text-lg">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-500 text-sm">
                            {testimonial.date}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center mb-3">
                        <StarRating rating={testimonial.rating} />
                        {testimonial && <VerifiedBadge />}
                      </div>
                      <p className="text-gray-700 text-base leading-relaxed flex-grow line-clamp-4">
                        {testimonial.review}
                      </p>
                      <a
                        href="#"
                        className="text-blue-600 hover:underline mt-4 text-sm text-right"
                      >
                        Read more
                      </a>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={goToNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Next testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 rounded-full ${
                  // Logic to highlight dots based on the current set of visible testimonials
                  idx >= currentTestimonialIndex &&
                  idx < currentTestimonialIndex + visibleCount
                    ? "bg-blue-600"
                    : "bg-gray-300"
                } transition-colors duration-300`}
                onClick={() => setCurrentTestimonialIndex(idx)}
                aria-label={`Go to testimonial group ${idx + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>
      {/* Conditionally render the popup */}
            {isPopupOpen && (
              <JoinNowFormPopup
                onClose={handleClosePopup}
                courseTitle={selectedCourseTitle}
              />
            )}
    </div>
  );
};

export default MernCertification;